import { render, staticRenderFns } from "./materialAccountDetail.vue?vue&type=template&id=411648ad&scoped=true"
import script from "./materialAccountDetail.vue?vue&type=script&lang=js"
export * from "./materialAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./materialAccountDetail.vue?vue&type=style&index=0&id=411648ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411648ad",
  null
  
)

export default component.exports